import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import HistoricoPedidoEmAndamentoPDF from "./PDF/HistoricoPedidoEmAndamentoPDF.vue"
import Tools from "@/shared/services/tools";
// import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";

const name = 'HistoricoPedidoEmAndamento'

export default {
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    HistoricoPedidoEmAndamentoPDF
  },

  props: { },

  mounted() {
    var pedId = this.$route.params.id
    this.PedidoId = pedId
    this.getDetalhesDoPedido();
    this.GetHistoricoDoPedido();
   },

  updated() { },

  data() {
    return {
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      numeroParcela: '',
      codigoPedido: '',
      HistoricoParcelasArray:[],
      mensagemvazio: false,
      PedidoId: null,
      executarvisualizacao: 0,
      renderiza: false,
      Colunas: [
        { field: "horaAlteracaoFormatada", header: "Data" },
        { field: "nome", header: "Usuário" },
        { field: "descricaoCausa", header: "Causa" },
        { field: "nomeSolicitante", header: "Solicitante" },
        { field: "descricaoCargo", header: "Cargo" },
        { field: "tipoManutencao", header: "Tipo da Manutenção" },
    ],

      ColunasSubGrid: [
        { field: "descricaoObservacao", header: "Observação" },
        { field: "descricaoAlteracao", header: "Alteração" },
    ],
    
    }
  },

  methods: {
    gerarPdf() {
      this.executarvisualizacao++
    },
    voltar() {
      this.$router.back()
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },

    GetHistoricoDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetHistoricoDoPedido/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          this.codigoPedido = response.data.data[0].codigoPedido;
          this.numeroParcela = response.data.data[0].numeroParcela;
          this.HistoricoParcelasArray = response.data.data;
        })
        .catch(() => {
        });
    },
    imprimir()
    {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },
  },

  computed: { }
};